module.exports = __webpack_public_path__ + "static/media/Cairo-Regular.3abc6f6f.woff";